$(document).ready(function(){
  $('.search-icon>a').click(function(e){
    e.preventDefault();
    $('.search-modal').toggleClass('active');
  })

  $('.search-modal__close').click(function(e){
    e.preventDefault();
    $('.search-modal').removeClass('active')
  })
})